import { ApiError, CancelButton, SubmitButton } from "components";
import { connect, useSelector } from "react-redux";
import { FormEvent, useEffect, useState } from "react";
import { FeaturedAdsStatusEnum } from "props/enum";
import { ResetFeaturedAds, updateFeaturedAds } from "../state/action";
import { FeaturedAdsInput, FeaturedAdsProps, stateStatusType } from "../state/actionType";

interface OwnProps {
  featuredaAdsData: FeaturedAdsProps;
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleChangeStatus: React.FC<Props> = ({
  featuredaAdsData,
  onResetFeaturedAds,
  onUpdateFeaturedAds,
  onClose,
}) => {
  const featuredAdsState = useSelector(
    (state: any) => state.featuredAds.genericFeaturedAdsState
  );
  const [formData, setFormData] = useState<FeaturedAdsInput>({
    featured_type: featuredaAdsData?.featured_type,
    status: featuredaAdsData?.status,
    image: featuredaAdsData?.image,
    video: featuredaAdsData?.video,
    featured_order: featuredaAdsData?.featured_order,
    name: featuredaAdsData?.name,
  });
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    const input: FeaturedAdsInput = {
      name: featuredaAdsData?.name,
      featured_type: featuredaAdsData?.featured_type,
      status:
        featuredaAdsData.status === FeaturedAdsStatusEnum.Published
          ? FeaturedAdsStatusEnum.Draft
          : FeaturedAdsStatusEnum.Published,
      featured_order: featuredaAdsData?.featured_order,
      image: featuredaAdsData?.image || "",
    };
    const ad_id = featuredaAdsData?.id?.toString();
    onUpdateFeaturedAds(input, ad_id);
  };
  const currentStatus = featuredaAdsData?.status;
  const newStatus =
    currentStatus === FeaturedAdsStatusEnum.Published
      ? FeaturedAdsStatusEnum.Draft
      : FeaturedAdsStatusEnum.Published;
  useEffect(() => {
    if (!featuredAdsState.isLoading && submitted) {
      if (featuredAdsState.error) {
        setApiError(featuredAdsState.error);
      } else if (featuredAdsState.status === stateStatusType.SUCCESS) {
        onClose();
        onResetFeaturedAds();
      } else {
        setApiError(null);
      }
    }
  }, [
    featuredAdsState.isLoading,
    featuredAdsState.error,
    featuredAdsState.status,
    submitted,
  ]);
  useEffect(() => {
    onResetFeaturedAds();
  }, []);
  return (
    <>
      {" "}
      <div className="text-center font-bold my-2 text-lg">Confirmation</div>
      <div className="text-center font-bold text-md my-5">
        Are you sure, you want to {newStatus}?
      </div>
      <div className="flex justify-evenly">
        <CancelButton onClick={onClose}>No</CancelButton>
        <SubmitButton
          onClick={(e) => {
            handleSave(e);
          }}
        >
          Yes
        </SubmitButton>
      </div>
      <div>{apiError && <ApiError>{apiError}</ApiError>}</div>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateFeaturedAds: (input: FeaturedAdsInput, ad_id: string) =>
    dispatch(updateFeaturedAds(input, ad_id)),
  onResetFeaturedAds: () => dispatch(ResetFeaturedAds()),
});
export default connect(null, mapDispatchToProps)(HandleChangeStatus);
